import { render } from "./MenuCalificacionesColaboradores.vue?vue&type=template&id=06ea926e"
import script from "./MenuCalificacionesColaboradores.vue?vue&type=script&lang=js"
export * from "./MenuCalificacionesColaboradores.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__